import { ControlPackage } from '@controls/Base';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { createElement } from 'react';
import Control from './Control';
import Label from './Label';
import Props from './Props';
import PropsDescriptor from './PropsDescriptor';
import renderFDO from './RenderFDO';

const createLabel = (parentId?: number | undefined): Control => ({
    globalId: -1,
    parentId,
    name: 'NewLabel',
    type: 'label',
    properties: {
        caption: 'New Label',
        position: {
            placement: 'precise',
            top: 0,
            left: 0,
            width: 96,
            height: 32,
        },
        bgColor: 'transparent',
        foreColor: '#000000',
        fontFace: 'arial',
        fontSize: 12,
        fontBold: false,
        fontItalic: false,
        fontUnderline: false,
    },
});

const upgradePropsVersion = (props: Props) => ({ ...props });

const labelPackage: ControlPackage<Props, Control> = {
    type: 'label',
    icon: solid('tag'),
    canHaveChildren: false,
    canHaveAction: false,
    validParentTypes: ['window'],
    factory: createLabel,
    propDescriptors: PropsDescriptor,
    renderDesigner: controlId => createElement(Label, { controlId }),
    renderFDO,
    upgradePropsVersion,
};

export default labelPackage;
